var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h3',[_vm._v(_vm._s(_vm.q))])]),_c('div',{staticClass:"answer"},[_vm._t("a")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }